import { render, staticRenderFns } from "./TaskRecord.vue?vue&type=template&id=b31ae516&scoped=true&"
import script from "./TaskRecord.vue?vue&type=script&lang=js&"
export * from "./TaskRecord.vue?vue&type=script&lang=js&"
import style0 from "./TaskRecord.vue?vue&type=style&index=0&id=b31ae516&prod&scoped=true&lang=css&"
import style1 from "./TaskRecord.vue?vue&type=style&index=1&id=b31ae516&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31ae516",
  null
  
)

export default component.exports